const STRIP_KEYS = new Set(['_id', 'id', 'company', 'creator', 'createdAt', 'updatedAt', '__v']);

export default function sanitizeAgenticBody(body) {
  if (!body || typeof body !== 'object') return body;
  const cleaned = {};
  Object.entries(body).forEach(([key, value]) => {
    if (!STRIP_KEYS.has(key)) cleaned[key] = value;
  });
  return cleaned;
}
